import { useEffect } from 'react'
import { AmplitudeRequiredCookieConsentGroup } from '../../GlobalVariables/Amplitude'
import { AmplitudeInitProps } from '../../types/Scripts'
import { getActiveOneTrustGroups } from '../../utils/onetrust-utils'

let hasInitialized = false

const AmplitudeWebExperiment = ({ apiKey, nonce }: AmplitudeInitProps) => {
  useEffect(() => {
    if (typeof window === 'undefined' || !apiKey) return

    let script: HTMLScriptElement | undefined

    const loadIfConsented = (): void => {
      if (hasInitialized) return
      if (!getActiveOneTrustGroups().includes(AmplitudeRequiredCookieConsentGroup)) return
      hasInitialized = true

      script = document.createElement('script')
      script.nonce = nonce
      script.src = `https://cdn.eu.amplitude.com/script/${apiKey}.experiment.js`
      document.head.appendChild(script)
    }

    loadIfConsented()
    window.addEventListener('OneTrustGroupsUpdated', loadIfConsented)
    ;(
      window as { OneTrust?: { OnConsentChanged?(cb: () => void): void } }
    ).OneTrust?.OnConsentChanged?.(loadIfConsented)

    return () => {
      window.removeEventListener('OneTrustGroupsUpdated', loadIfConsented)
      if (script?.parentNode) {
        script.parentNode.removeChild(script)
      }
    }
  }, [apiKey, nonce])

  return null
}

export default AmplitudeWebExperiment
